export type TipoFuente = 'evento' | 'webinar' | 'campana' | 'formulario' | 'manual'

export interface Fuente {
  id: string
  nombre: string
  tipo: TipoFuente | string
  prioridad: number
  activa: boolean
  created_at: string | null
}

export interface FuenteCreateInput {
  nombre: string
  tipo: string
  prioridad: number
}

export interface FuenteUpdateInput {
  nombre?: string
  tipo?: string
  prioridad?: number
  activa?: boolean
}

export const TIPOS_FUENTE: { value: TipoFuente; label: string }[] = [
  { value: 'evento', label: 'Evento' },
  { value: 'webinar', label: 'Webinar' },
  { value: 'campana', label: 'Campaña' },
  { value: 'formulario', label: 'Formulario' },
  { value: 'manual', label: 'Manual' },
]
